import { render, staticRenderFns } from "./DistributorCustomers.vue?vue&type=template&id=b01a3598"
import script from "./DistributorCustomers.vue?vue&type=script&lang=js"
export * from "./DistributorCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports